<template>
  <div class="wrapper">
    <Sidebar />
    <div id="content-wrapper" class="d-flex flex-column">
      <div id="content">
        <Topbar />
        <div class="container-fluid">
          <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">权限管理</h1>
            <button @click="showAddModal = true" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
              <i class="bi bi-plus"></i> 添加权限
            </button>
          </div>

          <div class="card shadow mb-4">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">权限列表</h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered" width="100%" cellspacing="0">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>权限标识</th>
                      <th>权限名称</th>
                      <th>所属模块</th>
                      <th>描述</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="perm in permissions" :key="perm.id">
                      <td>{{ perm.id }}</td>
                      <td>{{ perm.code }}</td>
                      <td>{{ perm.name }}</td>
                      <td>{{ perm.module }}</td>
                      <td>{{ perm.description }}</td>
                      <td>
                        <button @click="editPerm(perm)" class="btn btn-info btn-sm">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button @click="deletePerm(perm.id)" class="btn btn-danger btn-sm ml-1">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="sticky-footer bg-white">
        <div class="container my-auto">
          <div class="copyright text-center my-auto">
            <span>Copyright © 2024 管理系统</span>
          </div>
        </div>
      </footer>
    </div>

    <div class="modal" :class="{ show: showAddModal, 'd-block': showAddModal }" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ editingPerm ? '编辑权限' : '添加权限' }}</h5>
            <button type="button" @click="closeModal" class="close">&times;</button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="savePerm">
              <div class="form-group">
                <label>权限标识</label>
                <input v-model="form.code" type="text" class="form-control" required>
              </div>
              <div class="form-group">
                <label>权限名称</label>
                <input v-model="form.name" type="text" class="form-control" required>
              </div>
              <div class="form-group">
                <label>所属模块</label>
                <select v-model="form.module" class="form-control">
                  <option>用户管理</option>
                  <option>角色管理</option>
                  <option>组织管理</option>
                  <option>权限管理</option>
                  <option>日志管理</option>
                </select>
              </div>
              <div class="form-group">
                <label>描述</label>
                <textarea v-model="form.description" class="form-control"></textarea>
              </div>
              <button type="submit" class="btn btn-primary">保存</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import Sidebar from '../components/Sidebar.vue'
import Topbar from '../components/Topbar.vue'

const showAddModal = ref(false)
const editingPerm = ref(null)
const form = reactive({
  code: '',
  name: '',
  module: '',
  description: ''
})

const permissions = ref([
  { id: 1, code: 'user:view', name: '查看用户', module: '用户管理', description: '查看用户列表' },
  { id: 2, code: 'user:add', name: '添加用户', module: '用户管理', description: '添加新用户' },
  { id: 3, code: 'user:edit', name: '编辑用户', module: '用户管理', description: '编辑用户信息' },
  { id: 4, code: 'user:delete', name: '删除用户', module: '用户管理', description: '删除用户' },
  { id: 5, code: 'role:view', name: '查看角色', module: '角色管理', description: '查看角色列表' },
  { id: 6, code: 'role:add', name: '添加角色', module: '角色管理', description: '添加新角色' }
])

const editPerm = (perm) => {
  editingPerm.value = perm
  form.code = perm.code
  form.name = perm.name
  form.module = perm.module
  form.description = perm.description
  showAddModal.value = true
}

const deletePerm = async (id) => {
  if (await $confirm('确定删除该权限？')) {
    permissions.value = permissions.value.filter(p => p.id !== id)
  }
}

const savePerm = () => {
  if (editingPerm.value) {
    const index = permissions.value.findIndex(p => p.id === editingPerm.value.id)
    if (index !== -1) {
      permissions.value[index] = { ...permissions.value[index], ...form }
    }
  } else {
    permissions.value.push({
      id: Date.now(),
      ...form
    })
  }
  closeModal()
}

const closeModal = () => {
  showAddModal.value = false
  editingPerm.value = null
  form.code = ''
  form.name = ''
  form.module = ''
  form.description = ''
}
</script>